import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.linkedinApiUrl);

export const camelCaseHttp = createDashHttpClient(env.linkedinApiUrl, {
  camelizeKeys: true,
});

export async function getLinkedinAccount({ brandId }, config = {}) {
  return camelCaseHttp.get(`/brands/${brandId}/account/me`, config);
}

export function getLinkedinAccountAllBrands({ brandIds }, config = {}) {
  return camelCaseHttp.put(`/brands/accounts`, { brand_ids: brandIds }, config);
}
